import { LastActivityService } from '../../services/lastActivity/lastActivity.service';

export const loadLastActivityPaginate = async (payload) => {
    return new Promise(async (resolve, reject) => {
        try {
            const data = await LastActivityService.getLastActivityPaginate(payload);
            setTimeout(async () => {
                resolve(data.message?.activity ?? []);
            }, 1000)
        } catch (error) {
            console.log(error);
            resolve([]);
        }
    })

};
